import React from 'react'
import Ilustration from '../../../assets/img/onborading-first-step.svg'
import { useNavigate } from 'react-router-dom'


const StartingStep = ({
  setStep,
  user,
  isVideoWatched,
  isAppointmentBooked,
  license,
  questionnaireState,
  isVerify,
  taxpro_allow_appointments,
  isMessageSent,
  isPdfDownloaded
}) => {
  const navigate = useNavigate();

    const handleNext = () => {
        if (isVideoWatched) {
          if(!user?.LoginData?.settings?.isPasswordChanged){
             setStep((prev) => prev + 2);
            return;
          }
          if (!isVerify) {
            setStep((prev) => prev + 3);
            return;
          }
          if (taxpro_allow_appointments && isAppointmentBooked) {
               navigate(
              `?lead=${user?.LoginData?.lead?.[0]?.uuid}&customer=${user?.LoginData?.uuid}&operator=${user?.LoginData?.lead[0]?.userpro?.uuid}`,
              { replace: true }
            );
            setStep((prev) => prev + 4);
            return;
          }
          if (!license) {
            setStep((prev) => prev + 5);
            return;
          }
          if (questionnaireState?.value !== questionnaireState?.max) {
            setStep((prev) => prev + 6);
            return;
          }
          if (
            isAppointmentBooked &&
            license &&
            questionnaireState?.value === questionnaireState?.max
            && !isMessageSent
          ) {
            setStep((prev) => prev + 7);
            return;
          }
          if (
            isAppointmentBooked &&
            license &&
            questionnaireState?.value === questionnaireState?.max
            && isMessageSent && !isPdfDownloaded
          ) {
            setStep((prev) => prev + 8);
            return;
          }
          if (
            isAppointmentBooked &&
            license &&
            questionnaireState?.value === questionnaireState?.max
            && isMessageSent && isPdfDownloaded
          ) {
            setStep((prev) => prev + 9);
            return;
          }
        } else {
          setStep(1);
        }
      
  }

  return (
    <div className="container py-2 text-center">
      <div className="row align-items-center justify-content-center">
        <div className="col-md-6 mb-4 mb-md-0">
          <img
            src={Ilustration}
            alt="Watch Video"
            className="img-fluid"
          />
        </div>

        <div className="col-md-6 text-md-start" style={{maxWidth:'250px'}}>
            <span className='fs-4' role="img" aria-label="celebrate">
              🎉
            </span>
          <h5>
            {isVideoWatched ? '' : <><strong>Watch this video</strong> and</>} complete all steps to earn{" "}
            <span className="text-success fw-bold">$100 off</span> your first
            tax service
          </h5>
        </div>
      </div>
      <div className="mt-5">
        <button className="btn btn-primary px-4 py-2" onClick={handleNext}>
          Next Step <span className="ms-2">→</span>
        </button>
      </div>
    </div>
  )
}

export default StartingStep